import { render, staticRenderFns } from "./Anasazi.vue?vue&type=template&id=199b4961&scoped=true&"
import script from "./Anasazi.vue?vue&type=script&lang=js&"
export * from "./Anasazi.vue?vue&type=script&lang=js&"
import style0 from "./Anasazi.vue?vue&type=style&index=0&id=199b4961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b4961",
  null
  
)

export default component.exports